export default __webpack_public_path__ + "static/media/Bandit's Hood of the Ritual Flame.f84ac069.jpg";